import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useSelector } from 'react-redux';
import { nameToInitials } from '../helpers';
import { userInfoSelector } from '../state';

const Container = styled.div`
  text-align: center;
`;

const AvatarStyled = styled(Avatar)`
  width: 130px;
  height: 130px;
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.palette.primary.main},
    ${({ theme }) => theme.palette.primary.dark}
  );
  color: ${({ theme }) => theme.palette.primary.contrastText};
  box-shadow: ${({ theme }) => `0 18px 42px ${alpha(theme.palette.primary.main, 0.24)}`};
  font-size: ${({ theme }) => theme.typography.h3.fontSize};
  margin: auto;
`;

const TypographyUser = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

const UserAppInfo = () => {
  const { username, name } = useSelector(userInfoSelector) || { name: '', username: '' };
  const initials = nameToInitials(name);
  return (
    <Container>
      <AvatarStyled>{initials}</AvatarStyled>
      <Typography variant="h6">{name}</Typography>
      <TypographyUser variant="body2">{username}</TypographyUser>
      <TypographyUser variant="body2">{`Flex Ventas v${process.env.VERSION}`}</TypographyUser>
    </Container>
  );
};

export default UserAppInfo;
